import baseApi, { baseURL } from "utils/axios-instance";
import {
  CalendarConnection,
  CalendarKind,
  ProviderScheduling,
  ProviderSchedulingRow,
  WorkingHours,
  WritableCalendar,
} from "./types";

const ROOT = "/dashboard/inbound_calls";
const WITH_COOKIES = { withCredentials: true };

/** 404 when the team has never connected; callers branch on `error.response?.status`. */
export async function getCalendarConnection(): Promise<CalendarConnection> {
  const response = await baseApi.get<CalendarConnection>(
    `${ROOT}/calendar_connections/current`,
    WITH_COOKIES
  );
  return response.data;
}

/** 404 = never connected, 409 = needs reconnect. */
export async function listConnectionCalendars(): Promise<WritableCalendar[]> {
  const response = await baseApi.get<WritableCalendar[]>(
    `${ROOT}/calendar_connections/current/calendars`,
    WITH_COOKIES
  );
  return response.data;
}

/** Full-page navigation target: the server answers with a redirect to that provider's consent screen. */
export function connectCalendarUrl(kind: CalendarKind): string {
  return `${baseURL}${ROOT}/calendar_connections/connect?kind=${encodeURIComponent(kind)}`;
}

export async function disconnectCalendar(): Promise<void> {
  await baseApi.post(`${ROOT}/calendar_connections/disconnect`, {}, WITH_COOKIES);
}

export async function getProviders(): Promise<ProviderSchedulingRow[]> {
  const response = await baseApi.get<ProviderSchedulingRow[]>(
    `${ROOT}/providers`,
    WITH_COOKIES
  );
  return response.data;
}

export type ProviderSchedulingPatch = Partial<{
  is_active: boolean;
  accepting_new_patients: boolean;
  google_calendar_id: string;
  working_hours: WorkingHours;
}>;

/** Only the fields present are changed. `google_calendar_id: ""` and `working_hours: {}` clear. */
export async function updateProviderScheduling(
  providerId: string,
  patch: ProviderSchedulingPatch
): Promise<ProviderScheduling> {
  const response = await baseApi.put<ProviderScheduling>(
    `${ROOT}/providers/${providerId}/scheduling_settings`,
    patch,
    WITH_COOKIES
  );
  return response.data;
}

export function httpStatus(error: unknown): number | undefined {
  return (error as { response?: { status?: number } })?.response?.status;
}
